module.exports = __webpack_public_path__ + "static/img/tmallWash.5dce8791.png";